export default __webpack_public_path__ + "static/109-e06819aa9898c56ddc35c5c707deb86d.jpg";